<template>
  <v-container fluid class="pa-0 ma-3">
    <v-btn
      class="ma-2"
      @click="exportToExcel"
      append-icon="mdi-file-excel"
      variant="outlined"
      >Excel</v-btn
    >
    <v-btn
      class="ma-2"
      @click="print"
      append-icon="mdi-printer"
      variant="outlined"
      >print</v-btn
    >

    <v-container>
      <v-form>
        <v-date-input
          variant="outlined"
          rounded
          label="من"
          v-model="date1"
        ></v-date-input>
        <v-date-input
          variant="outlined"
          rounded
          label="إلى"
          v-model="date2"
        ></v-date-input>
      </v-form>

      <v-autocomplete
        class="ma-3"
        width="50%"
        v-model="accountant_id"
        label="المحاسب"
        :items="filteredAccountants"
        item-title="fullname"
        item-text=""
        item-value="id"
        placeholder="Search by accountant"
        prepend-inner-icon="mdi-magnify"
        menu-icon=""
        rounded
        theme="light"
        variant="solo"
        auto-select-first
        item-props
      ></v-autocomplete>
    </v-container>
    <v-container>
      <v-div id="printArea" dir="rtl">
        <v-data-table
          v-model="selected"
          :items="accTransactions"
          :headers="headers"
        >
          <template v-slot:no-data>
            <h3>No data available</h3>
          </template>
          <template v-slot:[`item.transactionType`]="{ item }">
            <v-container>
              <p class="text-red" v-if="item.transactionType == 'withdraw'">
                {{ $t(`${item.transactionType}`) }}
              </p>
              <p class="text-green" v-if="item.transactionType == 'feed'">
                {{ $t(`${item.transactionType}`) }}
              </p>
            </v-container>
          </template>
          <!-- <template v-slot:[`item.amount`]="{ item }">
            <v-container>
              <p>{{ item.last_reading - item.last_paid }}</p>
            </v-container>
          </template>-->
        </v-data-table>
      </v-div>
    </v-container>
  </v-container>
  <overlay-loader v-model="loading" />
</template>

<script>
import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";
import { VDateInput } from "vuetify/labs/VDateInput";

import * as XLSX from "xlsx";

export default {
  components: {
    VDateInput,
    OverlayLoader,
  },
  data: () => ({
    date1: null,
    date2: null,
    accountant_id: -1,
    headers: [
      { title: "النوع", key: "transactionType" },
      { title: "القيمة", key: "value" },
      { title: "الرصيد السابق", key: "old_balance" },
      { title: "الرصيد الحالي", key: "current_balance" },
      { title: "تاريخ العملية", key: "created_at" },
    ],
    loading: false,
    dialog: false,
  }),
  computed: {
    transactions() {
      return repo.transactions.getAllTransactions();
    },
    accTransactions() {
      if (this.accountant_id == -1) {
        return [];
      }
      let uu = this.transactions.filter(
        (x) => x.accountant_id == this.accountant_id
      );
      console.log("uu", uu);
      return uu;
    },
    accountants() {
      return repo.users.getAllUsers();
    },
    filteredAccountants() {
      console.log("users", this.accountants);
      const fa = this.accountants.filter((u) => {
        if (u.roles.some((obj) => obj.rolename === "accountant")) {
          return true;
        }
      });
      console.log("fa", fa);
      return fa;
    },
    dataToExport() {
      const res = this.accTransactions.map(
        ({
          transactionType,
          value,
          old_balance,
          current_balance,
          created_at,
        }) => ({
          transactionType: transactionType,
          value: value,
          old_balance: old_balance,
          current_balance: current_balance,
          created_at: created_at,
        })
      );
      return res;
    },
  },
  methods: {
    exportToExcel() {
      // Create a worksheet from the data
      const worksheet = XLSX.utils.json_to_sheet(this.dataToExport);

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Export the workbook to a file
      XLSX.writeFile(workbook, "data.xlsx");
    },
    print() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
    <html>
        <head>
            <title>Print Content</title>
            <style>
                @media print {
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 0;
                        height: 100vh;  /* Ensure the body takes full height */
                        padding: 20px;
                        box-sizing: border-box; /* Include padding in width calculations */
                    }
                    @page {
                        margin: 0;
                    }
                }
            </style>
        </head>
        <body dir=rtl>
            ${printContent}
        </body>
    </html>
`);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    async fetch() {
      this.loading = true;
      const res = await repo.transactions.fetchAll();
      const res2 = await repo.users.fetchAll();
      if (res && res2) {
        //swalFun.success("success");
        console.log(res2);
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
